import { render, staticRenderFns } from "./pdf_pc.vue?vue&type=template&id=286fe6ea&scoped=true&"
import script from "./pdf_pc.vue?vue&type=script&lang=js&"
export * from "./pdf_pc.vue?vue&type=script&lang=js&"
import style0 from "./pdf_pc.vue?vue&type=style&index=0&id=286fe6ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fe6ea",
  null
  
)

export default component.exports